import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ================= THUNK =================
export const fetchPlans = createAsyncThunk(
  "plans/fetchPlans",
  async (_, { rejectWithValue }) => {
    try {
      const baseUrl =
        process.env.REACT_APP_BACKEND_BASE_URL ||
        "http://localhost:5000/api";

      const response = await fetch(`${baseUrl}/plans`);

      if (!response.ok) {
        throw new Error("Failed to fetch plans");
      }

      const data = await response.json();

      return data.plans || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ================= SLICE =================
const plansSlice = createSlice({
  name: "plans",
  initialState: {
    plans: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default plansSlice.reducer;